import React from 'react';
import PropTypes from 'prop-types';
import CostObjAllocationUnit from './c/CostObjAllocationUnit';
import AddIcon from '@material-ui/icons/AddCircle';

const emptyAllocationUnit = {
  id: 0,
  unitCount: '',
  unitCountAvailable: '',
  originalUnitCountAvailable: 0,
  totalCountAvailable: 0
};

class ManageCostObjAllocationUnits extends React.Component {
  constructor(props) {
    super(props);
    if (props.costObjAllocationUnits.length > 0) {
      this.state = {
        originalCostObjAllocationUnits: [...props.costObjAllocationUnits],
        showRemoveIcon: false,
        costObjAllocationUnits: props.costObjAllocationUnits.map(allocUnit => ({
          ...allocUnit,
          originalUnitCountAvailable: allocUnit.unitCountAvailable + allocUnit.unitCount
        }))
      };
    } else {
      this.state = {
        ...emptyAllocationUnit
      };
    }
  }

  componentDidMount = () => {
    this.props.allocationUnitsActions.fetchAllAllocationUnits();
    this.setShowRemoveIcon();
    this.setTotalValueForEachAllocUnit();
  }
    

  componentWillReceiveProps(nextProps) {
    if (
      this.props.fetchingAllocationUnits &&
      !nextProps.fetchingAllocationUnits
    ) {
      this.props.costObjAllocationUnits.map(allocUnit => {
        this.props.allocationUnitsActions.selectCostObjAllocationUnit(
          0,
          allocUnit.id
        );
      });
    }
  }

  setShowRemoveIcon = () => {
    this.setState({ 
      showRemoveIcon: this.state.costObjAllocationUnits.length > 1
    });
  }

  setTotalValueForEachAllocUnit = () => {
    const allocationUnits = this.state.costObjAllocationUnits;
    allocationUnits.forEach( allocUnit => {
      allocUnit.totalAvailable = allocUnit.unitCountAvailable + allocUnit.unitCount;
    });
    this.setState({ costObjAllocationUnits: [...allocationUnits] });
  }

  handleAllocationUnitChange = (newCostObjAllocationUnit, index) => {
    const newCostObjAllocationUnits = this.state.costObjAllocationUnits.map(
      (allocationUnit, newIndex) => {
        if (index !== newIndex) return { ...allocationUnit };
        return { ...newCostObjAllocationUnit };
      }
    );
    this.setState({ costObjAllocationUnits: [...newCostObjAllocationUnits] });
    this.props.onAllocationUnitChange(newCostObjAllocationUnits);
  };

  handleAddAllocationUnit = () => {
    let newCostObjAllocationUnits = [...this.state.costObjAllocationUnits];
    this.setState({ costObjAllocationUnits: [] }, () => {
      this.setState(
        {
          costObjAllocationUnits: [
            ...newCostObjAllocationUnits,
            emptyAllocationUnit
          ]
        },
        () => {
          this.setState({
            showRemoveIcon: this.state.costObjAllocationUnits.length > 1
          });
          this.props.onAllocationUnitChange(this.state.costObjAllocationUnits);
        }
      );
    });
  };

  handleRemoveAllocationUnit = index => {
    let newCostObjAllocationUnits = [...this.state.costObjAllocationUnits];
    newCostObjAllocationUnits.splice(index, 1);
    this.setState({ costObjAllocationUnits: [] }, () => {
      this.setState(
        { costObjAllocationUnits: [...newCostObjAllocationUnits] },
        () => {
          this.setState({
            showRemoveIcon: this.state.costObjAllocationUnits.length > 1
          });
          this.props.onAllocationUnitChange(this.state.costObjAllocationUnits);
        }
      );
    });
  };

  handleSelectAllocationUnitChange = (oldAllocationUnit, newAllocationUnit) =>
    this.props.allocationUnitsActions.selectCostObjAllocationUnit(
      oldAllocationUnit,
      newAllocationUnit
    );

  render() {
    const { showRemoveIcon, costObjAllocationUnits, originalCostObjAllocationUnits } = this.state;
    const { allocationUnits, fetchingAllocationUnits } = this.props;
    return (
      <div>
        {costObjAllocationUnits.map((allocationUnit, index) => (
          <CostObjAllocationUnit
            key={ index }
            allocationUnit={ allocationUnit }
            showRemoveIcon={ showRemoveIcon }
            showAddIcon={ index + 1 === costObjAllocationUnits.length }
            allocationUnits={ allocationUnits }
            fetchingAllocationUnits={ fetchingAllocationUnits }
            originalCostObjAllocationUnits={ originalCostObjAllocationUnits }
            emptyAllocationUnit={ emptyAllocationUnit }
            onRemoveAllocationUnit={ () =>
              this.handleRemoveAllocationUnit(index)
            }
            onAllocationUnitChange={ newCostObjAllocationUnit =>
              this.handleAllocationUnitChange(newCostObjAllocationUnit, index)
            }
            onSelectAllocationUnitChange={ this.handleSelectAllocationUnitChange }
          />
        ))}
        <div className="cost-obj-add-allocation-container">
          <AddIcon
            style={ { fontSize: 18, marginRight: 5 } }
            onClick={ this.handleAddAllocationUnit }
          />
          <div style={ { fontSize: 14 } } onClick={ this.handleAddAllocationUnit }>
            ADD ALLOCATION UNIT
          </div>
        </div>
      </div>
    );
  }
}

ManageCostObjAllocationUnits.propTypes = {
  fetchingAllocationUnits: PropTypes.bool,
  onAllocationUnitChange: PropTypes.func.isRequired,
  costObjAllocationUnits: PropTypes.array.isRequired,
  allocationUnits: PropTypes.array.isRequired,
  allocationUnitsActions: PropTypes.shape({
    fetchAllAllocationUnits: PropTypes.func.isRequired,
    selectCostObjAllocationUnit: PropTypes.func.isRequired
  }).isRequired
};

ManageCostObjAllocationUnits.defaultProps = {
  fetchingAllocationUnits: false
};

export default ManageCostObjAllocationUnits;



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditor/ManageCostObjAllocationUnits.js